import { useState, useEffect, useCallback } from 'react';
import { ICNVisionResults, ICNVisionSetup, ICNVisionTest } from '..';
import { useTestContext } from '../../../context/testContext';
import { usePostMessage } from '../../../context/messageContext';
import ExamEyeSetup from '../exams/ExamEyeSetup';
import { ExamBody, useExamStep } from '../exams/common';

const ICNVision = ({ setTitle, setActiveTab }) => {
  const { testData, updateTestData } = useTestContext();
  const [step, setStep] = useState('eyeSetup');
  const postMessage = usePostMessage();
  useExamStep(testData.testKey, step);

  useEffect(() => {
    switch (step) {
      case 'eyeSetup':
        return setTitle('Near Vision');
      case 'rightEyeSetup':
      case 'rightEyeTest':
        return setTitle('Near Vision - Right Eye');
      case 'leftEyeSetup':
      case 'leftEyeTest':
        return setTitle('Near Vision - Left Eye');
      case 'bothEyesSetup':
      case 'bothEyesTest':
        return setTitle('Near Vision - Binocular');
      case 'results':
        setTitle('Near Vision Results');
        break;
      default:
        break;
    }
  }, [setTitle, step, updateTestData]);

  const updateStep = (selectedStep) => {
    if (selectedStep === 'results') postMessage({ type: 'endOfTest' });
    if (selectedStep.endsWith('Setup')) postMessage({ type: 'holding' });
    if (selectedStep.endsWith('Test')) {
      postMessage({
        type: 'optimaChart',
        content: {},
      });
    }
    setStep(selectedStep);
  };

  const updateTextContents = useCallback(
    (textContents) => {
      postMessage({
        type: 'optimaTextContents',
        content: {
          textContents: textContents,
        },
      });
    },
    [postMessage],
  );

  const renderSwitch = () => {
    switch (step) {
      case 'eyeSetup':
        return <ExamEyeSetup updateStep={updateStep} />;
      case 'bothEyesSetup':
      case 'rightEyeSetup':
      case 'leftEyeSetup':
        return <ICNVisionSetup eyeTested={step.split('S')[0]} updateStep={updateStep} />;
      case 'rightEyeTest':
      case 'leftEyeTest':
      case 'bothEyesTest':
        return <ICNVisionTest eyeTested={step.split('T')[0]} updateTextContents={updateTextContents} updateStep={updateStep} />;
      case 'results':
        return <ICNVisionResults localResults={testData} setActiveTab={setActiveTab} updateStep={updateStep} />;
      default:
        return;
    }
  };

  return <ExamBody>{renderSwitch()}</ExamBody>;
};

export default ICNVision;
